import styled from 'styled-components';
import { defaultMuiTheme } from '../../styles/MaterialTheme';
export const CollectionTabContainer = styled.div `
    width: 40%;
    max-width: 700px;
    margin-left: 2rem;
    position: sticky;
    top: 48px;

    ${defaultMuiTheme.breakpoints.down('md')} {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
`;
export const CollectionTopContainer = styled.div `
    align-items: center;
    display: flex;
    padding: 2rem;
    position: relative;
    max-height: 900px;
    color: ${(props) => props.theme.colors.black};

    ${defaultMuiTheme.breakpoints.down('md')} {
        padding: 0;
    }
`;
export const CollectionBottomContainer = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 2rem 2rem 2rem;
    position: relative;

    ${defaultMuiTheme.breakpoints.down('md')} {
        padding: 0;
        flex-direction: column;
    }
`;
export const CollectionAboutContainer = styled.div `
    width: 60%;
    display: flex;
    max-width: 700px;
    flex-direction: column;
    padding: 4rem 0 4rem 4rem;
    z-index: 1;
    background-color: transparent;

    ${defaultMuiTheme.breakpoints.down('md')} {
        padding: 4rem 0;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
    }

    ${defaultMuiTheme.breakpoints.down('sm')} {
        padding: 2rem 1.5rem;
    }
`;
export const CollectionDescriptionContainer = styled.div `
    width: 60%;
    max-width: 700px;
    position: relative;

    ${defaultMuiTheme.breakpoints.down('md')} {
        width: 100%;
        padding: 1rem;
    }
`;
//# sourceMappingURL=Collection.styles.js.map